'use client'

import {
  Box,
  Flex,
  Text,
  Button,
  Stack,
  Popover,
  PopoverTrigger,
  PopoverContent,
  useColorModeValue,
  useBreakpointValue,
  PopoverArrow,
  PopoverBody,
  Link,
  Grid,
  GridItem,
  useDisclosure,
  HStack,
} from '@chakra-ui/react'
import { LOGO_FONT_SIZE, SPACING } from '../constants/Constants'
import { isMobile } from 'react-device-detect'
import { HOME, MISC, PRESTUDY_SPLITTER } from '../constants/Routes'
import { ChevronDownIcon, StarIcon } from '@chakra-ui/icons'
import { FaEyeSlash } from 'react-icons/fa'

export default function Navbar() {
  const { isOpen, onToggle, onClose } = useDisclosure();

  const hadleClose = async () => {
    await new Promise((resolve) => setTimeout(resolve, 150));
    onClose();
  }


  return (

    <Box>
      <Flex
        bg={useColorModeValue('white', 'gray.700')}
        color={useColorModeValue('gray.600', 'white')}
        minH={'auto'}
        py={{ base: 2 }}
        px={{ base: 4 }}
        width={"100%"}
        borderBottom={1}
        borderStyle={'solid'}
        borderColor={useColorModeValue('gray.200', 'gray.900')}
        align={'center'}
        justifyContent={'space-between'}
        alignContent={"center"}
      >

        <Flex cursor={"pointer"} align={"baseline"} onClick={() => window.open(HOME, "_self")}>
          <Text
            fontWeight={"bold"}
            fontSize={LOGO_FONT_SIZE}
            textAlign={useBreakpointValue({ base: 'center', md: 'left' })}
            fontFamily={'heading'}
            color={useColorModeValue('gray.700', 'white')}>
            Code F
          </Text>
          <Text
            ml={SPACING / 2.5}
            fontSize={LOGO_FONT_SIZE / 1.5}
            textAlign={useBreakpointValue({ base: 'center', md: 'left' })}
            fontFamily={'heading'}
            color={useColorModeValue('gray.700', 'white')}>
            AB
          </Text>
        </Flex>
        <Flex />
        <Flex>
          <Popover arrowSize={isMobile ? LOGO_FONT_SIZE : LOGO_FONT_SIZE / 2} isOpen={isOpen} closeOnBlur={true} onClose={hadleClose}>
            <PopoverTrigger>
              <Flex direction="row" align="center" cursor={"pointer"} onClick={onToggle}>
                <Text
                  userSelect={"none"}
                  fontWeight={"bold"}
                  fontSize={LOGO_FONT_SIZE}
                  textAlign={useBreakpointValue({ base: 'center', md: 'left' })}
                  fontFamily={'heading'}
                  color={useColorModeValue('gray.700', 'white')}
                >
                  Products
                </Text>
                <ChevronDownIcon fontSize={LOGO_FONT_SIZE} ml={2} />
              </Flex>
            </PopoverTrigger>
            <PopoverContent width={"60vw"}>
              <PopoverArrow />
              <PopoverBody >
                <Grid templateColumns="repeat(3, 1fr)" gap={6}>
                  <GridItem colSpan={isMobile ? 3 : 1}>
                    <Text fontWeight={"bold"} fontSize={"large"}>Tailored systems</Text>
                    <Stack>
                      <Link href='/products/OMS'>
                        <HStack>
                          <Text>OMS - KLTS</Text>
                          <StarIcon color={"yellow.400"} />
                        </HStack>
                      </Link>
                      <Link href='/products/OMS-legacy'>
                        <Text style={{ textDecoration: 'line-through' }}>OMS - Legacy</Text>
                      </Link>
                    </Stack>
                  </GridItem>
                  <GridItem colSpan={isMobile ? 3 : 1}>
                    <Text fontWeight={"bold"} fontSize={"large"}>Generic systems</Text>
                    <Stack>
                      <Link>
                        <HStack>
                          <Text>Check-in</Text>
                          <FaEyeSlash />
                        </HStack>
                      </Link>
                    </Stack>
                  </GridItem>
                  <GridItem colSpan={isMobile ? 3 : 1}>
                    <Text fontWeight={"bold"} fontSize={"large"}>Miscellaneous</Text>
                    <Stack>
                      <Link href={MISC + PRESTUDY_SPLITTER}>
                        <HStack>
                          <Text>Prestudy splitter</Text>
                        </HStack>
                      </Link>
                      <Link>
                        <HStack>
                          <Text>TBA</Text>
                          <FaEyeSlash />
                        </HStack>
                      </Link>
                    </Stack>
                  </GridItem>
                  <GridItem>
                  </GridItem>
                </Grid>
              </PopoverBody>
            </PopoverContent>
          </Popover>
        </Flex>



        <Flex />


        {/* <ColorModeSwitcher justifySelf="flex-end" mr={SPACING} /> */}

        <Flex>
          <Button
            size={isMobile ? "xs" : "lg"}
            as={'a'}
            fontSize={isMobile ? "xs" : "md"}
            color={'white'}
            bg={'pink.400'}
            href={'mailto:codefab.dev@gmail.com'}
            _hover={{
              bg: 'pink.300',
            }}>
            Contact us
          </Button>
        </Flex>
      </Flex>
    </Box>
  )
}


interface NavItem {
  label: string
  subLabel?: string
  children?: Array<NavItem>
  href?: string
}

const NAV_ITEMS: Array<NavItem> = [
  {
    label: 'Inspiration',
    children: [
      {
        label: 'Explore Design Work',
        subLabel: 'Trending Design to inspire you',
        href: '#',
      },
      {
        label: 'New & Noteworthy',
        subLabel: 'Up-and-coming Designers',
        href: '#',
      },
    ],
  },
  {
    label: 'Find Work',
    children: [
      {
        label: 'Job Board',
        subLabel: 'Find your dream design job',
        href: '#',
      },
      {
        label: 'Freelance Projects',
        subLabel: 'An exclusive list for contract work',
        href: '#',
      },
    ],
  },
  {
    label: 'Learn Design',
    href: '#',
  },
  {
    label: 'Hire Designers',
    href: '#',
  },
]